import { createFileRoute } from '@tanstack/react-router';

import { CreateSessionPage } from '~pages/sessions';

export const Route = createFileRoute('/_auth/_layout/sessions/new')({
  component: RouteComponent,
});

function RouteComponent() {
  return <CreateSessionPage />;
}
